(() => {
  const SELECTOR = ".ProductItem__Tag--sold-out-since[data-sold-out-date]";
  const DAY_MS = 86400000;

  // Calendar-day difference between two dates, using the visitor's local day boundaries.
  const daysBetween = (from, to) => {
    const fromMidnight = new Date(from.getFullYear(), from.getMonth(), from.getDate());
    const toMidnight = new Date(to.getFullYear(), to.getMonth(), to.getDate());
    return Math.round((toMidnight - fromMidnight) / DAY_MS);
  };

  const labelFor = (el, days) => {
    if (days <= 0) return el.dataset.labelToday;
    if (days === 1) return el.dataset.labelYesterday;
    if (days <= 4) return el.dataset.labelDaysAgo;
    if (days <= 7) return el.dataset.labelThisWeek;
    return el.dataset.labelThisMonth;
  };

  const render = (el) => {
    if (el.dataset.soldOutRendered === "true") return;

    const epoch = parseInt(el.dataset.soldOutDate, 10);
    if (Number.isNaN(epoch)) return;

    const soldDate = new Date(epoch * 1000);
    const days = daysBetween(soldDate, new Date());
    const label = labelFor(el, days);

    if (label) {
      el.textContent = label;
      el.dataset.soldOutRendered = "true";
    }
  };

  const renderAll = (root = document) => {
    root.querySelectorAll(SELECTOR).forEach(render);
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => renderAll());
  } else {
    renderAll();
  }

  // Handle cards injected after load (infinite scroll, AJAX cart/side menu, etc.).
  const observer = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType !== Node.ELEMENT_NODE) return;
        if (node.matches && node.matches(SELECTOR)) render(node);
        if (node.querySelectorAll) renderAll(node);
      });
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });
})();
